/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const trax: CommunityData = {
  code: "trax",
  inviteCode: "trax",
  name: "TRAX",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/trx-111`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community-assets/trax/web-logo.png",
        styles: "w-[160px] h-[41px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/trax/web-alternative-logo.png",
        styles: "w-[160px] h-[41px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#030e55",
      asideBg: "#030e55",
      asideStyles: "border-r border-[#ffffff]",
      contentBg: "#030e55",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "font-['InconsolataRegular']",
      primaryButton:
        "bg-[#030e55] border border-[#ffffff] rounded-full px-[18px] py-[18px] !text-[#ffffff] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff]",
      separator: "#ffffff",
      item: "text-[#ffffff] font-['InterRegular'] text-[16px] text-left leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#ffffff] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#030e55] border-[#8ddba1] !pb-8",
      titles:
        "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#030e55] border border-[#8ddba1]",
          mediaContainer: "w-full sm:w-[256px] h-[256px] relative",
          media: "w-full h-[256px] object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['InconsolataRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff]",
        sectionTitle:
          "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#030e55] border border-[#8ddba1]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 h-[180px] relative",
          media: "w-full h-[180px] object-cover",
          placeholderMedia: "w-full h-[180px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['InconsolataRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['InconsolataRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['InconsolataRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['InconsolataRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "border border-[#ffffff] rounded-[16px]",
        sectionTitle:
          "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#030e55] border-[#8ddba1] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media:
          "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#ffffff] rounded-[16px]",
        title:
          "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#030e55] border border-[#ffffff] rounded-full px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['InconsolataRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['InconsolataRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#8ddba1",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['InconsolataRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['InconsolataRegular'] text-[28px] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6",
        outerContainer: "flex flex-col !bg-[#030e55] border-[#8ddba1] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#030e55] border-b border-[#8ddba1] mb-4 pb-2 sm:pb-4 overflow-hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[100%]",
          description:
            "text-[#ffffff] font-['InconsolataRegular'] text-[14px] text-left leading-[120%] !mt-1 flex flex-row",
          price:
            "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[100%] !mt-1",
          quantity: "text-[#000000] font-['InterRegular'] text-[14px] text-left leading-[100%]",
          status: "text-[#ffffff] font-['InconsolataRegular'] text-[16px] text-left leading-[100%]",
          counterContainer:
            "bg-[#a7a7a7] border border-[#ffffff] rounded-full !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#a7a7a7] border border-[#ffffff] rounded-full px-4 py-3 text-[#000000] font-['InterRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default trax
